import { Injectable, signal } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CAMCashApprovalAction, CAMEditHospitality } from '../interfaces/cashaccountmanagement.interface';
interface Activities {
 VESSEL_NAME:string,
 OTHER_VESSEL_NAME:string,
 VESSELTRX_ID: string,
 CAM_ACTIVE:false
}
@Injectable({
  providedIn: 'root'
})
export class CashAdvanceManagementService {
  activityData = signal<Activities>({
    VESSEL_NAME:'',
    OTHER_VESSEL_NAME: '',
    VESSELTRX_ID: '',
    CAM_ACTIVE:false
  })
  constructor(private readonly http: HttpClient) { }

  crewCashApprovalsList(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-cash-approvals`, postData);
  }
  raiseCashOrder(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/cash-orders`, postData);
  }
  cashOrderList(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/cash-orders?${query_string}`);
  }
  slopChestList(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/slopchests?${query_string}`);
  }
  pendingRequestsAction(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-cash-approvals/action`, postData);
  }

  fetchRequestDetails(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-cash-approvals/details`,postData);
  }
  addPortAgent(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/cash-orders/port-agent`,postData);
  }
  addSlopChest(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/slopchests`,postData);
  }
 
  fetchCashOrderDetails(id:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/cash-orders/${id}`);
  }
  fetchSlopChestDetails(id:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/slopchests/${id}`);
  }
  deleteCashOrder(id:string): Observable<any>{
    return this.http.delete(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/cash-orders/${id}`);
  }
  
  welfareList(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/welfares?${query_string}`);
  }

  welfareDetails(id:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/welfares/${id}`);
  }
  deleteWelfare(id:string): Observable<any>{
    return this.http.delete(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/welfares/${id}`);
  }

  addWelfare(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/welfares`, postData);
  }
  deleteSlopChest(id:string): Observable<any>{
    return this.http.delete(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/slopchests/${id}`);
  }

  fetchExpenseCurrencyExchange(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/expenses/currency/exchange?${query_string}`);
  }
  
  getExpensesLists(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-expenses?${query_string}`);
  }
  
  fetchExpenseDetails(id:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-expenses/${id}`);
  }

  fetchShipBalance(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/ship-balance?${query_string}`);
  }

  raiseExpense(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-expenses`, postData);
  }
  deleteExpense(id:string): Observable<any>{
    return this.http.delete(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-expenses/${id}`);
  }

  cashOrderAcknowledgement(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/cash-orders/acknowledge`, postData);
  }

  fetchHandoverData(): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-access`);
  }

  submitHandoverData(pastdata:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-access`,pastdata);
  }

  fetchFinancialOverview(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/financial-overview?${query_string}`);
  }

  getHospitalityLists(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/hospitalities?${query_string}`);
  }

 fetchHospitalityDetails(ids:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/hospitalities/details`,ids);
  }
  raiseHospitality(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/hospitalities`, postData);
  }
  uploadHospitalitiesFromFile(postData:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/hospitalities/excel/upload`, postData);
  }

  deleteHospitality(id:string): Observable<any>{
    return this.http.delete(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/hospitalities/${id}`);
  }
  uploadImage(imageBase64: any,endpoint:string, name:string,type?: string, data?:any): Observable<any> {
      let imageBlob:any;
      if(type==="image"){
        imageBlob = this.dataURItoBlob(imageBase64 as string);
      }
      else{
        imageBlob = imageBase64
      }
      const formData = new FormData();
      formData.append('file', imageBlob, name); // You can change the file name
      if(data.VESSEL_NAME){
        formData.append('VESSEL_NAME', data.VESSEL_NAME);
      }
      if(data.OTHER_VESSEL_NAME){
        formData.append('OTHER_VESSEL_NAME', data.OTHER_VESSEL_NAME);
      }
      if(data.VESSELTRX_ID){
        formData.append('VESSELTRX_ID', data.VESSELTRX_ID);
      }
      return  this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/${endpoint}`, formData,{headers: new HttpHeaders({})})
    }
    private dataURItoBlob(dataURI: string): Blob {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
  
      return new Blob([ab], { type: mimeString });
    }
  passSignal<T extends keyof CAMEditHospitality>(
    property: T,
    value: CAMEditHospitality[T] extends object ? Partial<CAMEditHospitality[T]> : CAMEditHospitality[T],
    settingSignal:any
  ) {
    settingSignal.update((state: CAMEditHospitality) => ({
      ...state,
      [property]:
        typeof state[property] === "object" && !Array.isArray(state[property])
          ? { ...(state[property] as object), ...(value as object) }
          : value,
    }));
  }

  passCashApprovalSignal<T extends keyof CAMCashApprovalAction>(
    property: T,
    value: CAMCashApprovalAction[T] extends object ? Partial<CAMCashApprovalAction[T]> : CAMCashApprovalAction[T],
    settingSignal:any
  ) {
    settingSignal.update((state: CAMCashApprovalAction) => ({
      ...state,
      [property]:
        typeof state[property] === "object" && !Array.isArray(state[property])
          ? { ...(state[property] as object), ...(value as object) }
          : value,
    }));
  }
  onCheckBoxSelection<T>(
    item: T | null,
    itemsList: T[],
    selectedItems: T[],
    identifier: keyof T
  ): T[] {
    if (item) {
      const index = selectedItems.findIndex((selected) => selected[identifier] === item[identifier]);
      if (index !== -1) {
        selectedItems.splice(index, 1);
      } else {
        selectedItems.push(item);
      }
    } else if (selectedItems.length === itemsList.length) {
      return [];
    } else {
      return itemsList.slice();
    }
    return [...selectedItems];
  }

  getCashApprovalLists(query_string:string): Observable<any>{
    return this.http.get(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-cash-approvals?${query_string}`);
  }

  fetchCashApprovalDetails(ids:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-cash-approvals/details`,ids);
  }
  cashApprovalActionSubmit(data:any): Observable<any>{
    return this.http.post(`${environment.CREW_APP_BACKEND_API_BASE_URL}/cash-management/crew-cash-approvals/action`,data);
  }
}